"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeFileName = normalizeFileName;
var _sanitizeFilename = _interopRequireDefault(require("sanitize-filename"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var forbiddenCharacters = /[%]/g;
var replacement = '_';
function normalizeFileName(filename) {
  var sanitize = (0, _sanitizeFilename["default"])(filename, {
    replacement: replacement
  });
  var normalized = sanitize.replaceAll(forbiddenCharacters, replacement);
  return normalized;
}